/**
 * @generated SignedSource<<fead545293f3564fd29e7820575b0c28>>
 * @relayHash df1dc856ca78182d690a424ff60de3fb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID fbdad4ae6c0b946b63a2ab7ff142f49477b7177311383f95962f6cb82714ea49

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraIssueFieldConfigWorkTypesAssociationInput = {
  schemeOrProject: JiraIssueFieldConfigSchemeOrProjectInput;
};
export type JiraIssueFieldConfigSchemeOrProjectInput = {
  projectKey?: string | null;
  schemeId?: string | null;
};
export type JiraIssueFieldConfigRequiredOnCustomisationsInput = {
  schemeOrProject: JiraIssueFieldConfigSchemeOrProjectInput;
};
export type JiraIssueFieldConfigDescriptionCustomisationsInput = {
  schemeOrProject: JiraIssueFieldConfigSchemeOrProjectInput;
};
export type ClassicProjectFieldsAppQuery$variables = {
  availableOnInput: JiraIssueFieldConfigWorkTypesAssociationInput;
  cloudId: string;
  descriptionsInput: JiraIssueFieldConfigDescriptionCustomisationsInput;
  projectKey: string;
  requiredOnInput: JiraIssueFieldConfigRequiredOnCustomisationsInput;
};
export type ClassicProjectFieldsAppQuery$data = {
  readonly jira: {
    readonly jiraProjectByKey: {
      readonly key: string;
      readonly projectId: string | null;
    } | null;
  } | null;
  readonly jira_isTenantConvertedToNfa: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"ClassicProjectFieldsPage_query">;
};
export type ClassicProjectFieldsAppQuery = {
  response: ClassicProjectFieldsAppQuery$data;
  variables: ClassicProjectFieldsAppQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "availableOnInput"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "descriptionsInput"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectKey"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "requiredOnInput"
},
v5 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v6 = [
  (v5/*: any*/),
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "projectKey"
  }
],
v7 = {
  "kind": "ScalarField",
  "name": "projectId"
},
v8 = {
  "kind": "ScalarField",
  "name": "key"
},
v9 = {
  "args": [
    (v5/*: any*/)
  ],
  "kind": "ScalarField",
  "name": "jira_isTenantConvertedToNfa"
},
v10 = {
  "kind": "ScalarField",
  "name": "id"
},
v11 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 40
  }
],
v12 = {
  "kind": "ScalarField",
  "name": "name"
},
v13 = {
  "kind": "ScalarField",
  "name": "description"
},
v14 = {
  "kind": "ScalarField",
  "name": "issueTypeId"
},
v15 = {
  "concreteType": "JiraAvatar",
  "kind": "LinkedField",
  "name": "avatar",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "xsmall"
    }
  ]
},
v16 = {
  "concreteType": "JiraIssueType",
  "kind": "LinkedField",
  "name": "workTypes",
  "plural": true,
  "selections": [
    (v10/*: any*/),
    (v14/*: any*/),
    (v12/*: any*/),
    (v15/*: any*/)
  ]
},
v17 = {
  "kind": "ScalarField",
  "name": "isDefault"
},
v18 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v19 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v20 = {
  "kind": "ScalarField",
  "name": "hasNextPage"
},
v21 = {
  "kind": "ScalarField",
  "name": "endCursor"
},
v22 = [
  "input"
],
v23 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    (v21/*: any*/),
    (v20/*: any*/)
  ]
},
v24 = [
  {
    "concreteType": "JiraIssueTypeEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "JiraIssueType",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v14/*: any*/),
          (v12/*: any*/),
          (v15/*: any*/),
          (v10/*: any*/),
          (v18/*: any*/)
        ]
      },
      (v19/*: any*/)
    ]
  },
  (v23/*: any*/)
],
v25 = [
  (v5/*: any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ClassicProjectFieldsAppQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v6/*: any*/),
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jiraProjectByKey",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              (v8/*: any*/)
            ]
          }
        ]
      },
      (v9/*: any*/),
      {
        "args": [
          {
            "kind": "Variable",
            "name": "availableOnInput",
            "variableName": "availableOnInput"
          },
          (v5/*: any*/),
          {
            "kind": "Variable",
            "name": "descriptionsInput",
            "variableName": "descriptionsInput"
          },
          {
            "kind": "Variable",
            "name": "projectKey",
            "variableName": "projectKey"
          },
          {
            "kind": "Variable",
            "name": "requiredOnInput",
            "variableName": "requiredOnInput"
          }
        ],
        "kind": "FragmentSpread",
        "name": "ClassicProjectFieldsPage_query"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/),
      (v4/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "ClassicProjectFieldsAppQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v6/*: any*/),
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jiraProjectByKey",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              (v8/*: any*/),
              (v10/*: any*/),
              {
                "args": (v11/*: any*/),
                "concreteType": "JiraFieldSchemeAssociatedFieldsConnection",
                "kind": "LinkedField",
                "name": "schemeAssociatedFields",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "totalCount"
                  },
                  {
                    "concreteType": "JiraFieldSchemeAssociatedFieldsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraFieldSchemeAssociatedField",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v10/*: any*/),
                          {
                            "concreteType": "JiraField",
                            "kind": "LinkedField",
                            "name": "field",
                            "plural": false,
                            "selections": [
                              (v10/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "fieldId"
                              },
                              (v12/*: any*/),
                              (v13/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "typeName"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "typeKey"
                              }
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "isFieldLocked"
                          },
                          {
                            "concreteType": "JiraIssueFieldConfig",
                            "kind": "LinkedField",
                            "name": "fieldConfig",
                            "plural": false,
                            "selections": [
                              (v10/*: any*/),
                              {
                                "args": [
                                  {
                                    "kind": "Variable",
                                    "name": "input",
                                    "variableName": "availableOnInput"
                                  }
                                ],
                                "concreteType": "JiraFieldToWorkTypesAssociation",
                                "kind": "LinkedField",
                                "name": "workTypesAssociationV2",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "availableOnAllWorkTypes"
                                  },
                                  (v16/*: any*/)
                                ]
                              },
                              {
                                "args": [
                                  {
                                    "kind": "Variable",
                                    "name": "input",
                                    "variableName": "requiredOnInput"
                                  }
                                ],
                                "concreteType": "JiraFieldWorkTypeRequiredCustomization",
                                "kind": "LinkedField",
                                "name": "requiredOnCustomizationsV2",
                                "plural": true,
                                "selections": [
                                  (v17/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "isRequired"
                                  },
                                  (v16/*: any*/)
                                ]
                              },
                              {
                                "args": [
                                  {
                                    "kind": "Variable",
                                    "name": "input",
                                    "variableName": "descriptionsInput"
                                  }
                                ],
                                "concreteType": "JiraFieldWorkTypeDescriptionCustomization",
                                "kind": "LinkedField",
                                "name": "descriptionCustomisationsV2",
                                "plural": true,
                                "selections": [
                                  (v17/*: any*/),
                                  (v13/*: any*/),
                                  {
                                    "concreteType": "JiraIssueType",
                                    "kind": "LinkedField",
                                    "name": "workTypes",
                                    "plural": true,
                                    "selections": [
                                      (v10/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          (v18/*: any*/)
                        ]
                      },
                      (v19/*: any*/)
                    ]
                  },
                  {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      (v20/*: any*/),
                      (v21/*: any*/)
                    ]
                  }
                ],
                "storageKey": "schemeAssociatedFields(first:40)"
              },
              {
                "args": (v11/*: any*/),
                "filters": (v22/*: any*/),
                "handle": "connection",
                "key": "classicProjectFieldsAssociatedFieldsTable_schemeAssociatedFields",
                "kind": "LinkedHandle",
                "name": "schemeAssociatedFields"
              },
              {
                "concreteType": "JiraIssueTypeConnection",
                "kind": "LinkedField",
                "name": "availableIssueTypes",
                "plural": false,
                "selections": (v24/*: any*/)
              },
              {
                "filters": (v22/*: any*/),
                "handle": "connection",
                "key": "FilterSelectWorkType_project_availableIssueTypes",
                "kind": "LinkedHandle",
                "name": "availableIssueTypes"
              },
              {
                "concreteType": "JiraIssueTypeConnection",
                "kind": "LinkedField",
                "name": "requiredOnIssueTypes",
                "plural": false,
                "selections": (v24/*: any*/)
              },
              {
                "filters": (v22/*: any*/),
                "handle": "connection",
                "key": "FilterSelectRequiredOn_project_requiredOnIssueTypes",
                "kind": "LinkedHandle",
                "name": "requiredOnIssueTypes"
              },
              (v12/*: any*/),
              {
                "concreteType": "JiraFieldScheme",
                "kind": "LinkedField",
                "name": "associatedFieldScheme",
                "plural": false,
                "selections": [
                  (v12/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "projectsCount"
                  },
                  (v10/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "schemeId"
                  }
                ]
              }
            ]
          }
        ]
      },
      (v9/*: any*/),
      {
        "args": (v25/*: any*/),
        "concreteType": "JiraFieldTypeGroupConnection",
        "kind": "LinkedField",
        "name": "jira_fieldTypeGroups",
        "plural": false,
        "selections": [
          {
            "concreteType": "JiraFieldTypeGroupEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "JiraFieldTypeGroup",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "displayName"
                  },
                  (v18/*: any*/)
                ]
              },
              (v19/*: any*/)
            ]
          },
          (v23/*: any*/)
        ]
      },
      {
        "args": (v25/*: any*/),
        "filters": [
          "cloudId"
        ],
        "handle": "connection",
        "key": "ClassicProjectFieldsFilterSelectFieldTypeCategory_query_jira_fieldTypeGroups",
        "kind": "LinkedHandle",
        "name": "jira_fieldTypeGroups"
      }
    ]
  },
  "params": {
    "id": "fbdad4ae6c0b946b63a2ab7ff142f49477b7177311383f95962f6cb82714ea49",
    "metadata": {},
    "name": "ClassicProjectFieldsAppQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "653cd9ad76539940aed411cf7beb7cc9";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
